<form [formGroup]="formGroup" (ngSubmit)="save()">
  <div class="modal-header">
    <div class="modal-title h5" id="modalTitle">Permission mapping settings</div>
    <button type="button" class="close" (click)="activeModal.close()" aria-label="Close modal?"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    @if (errorMessage) {
    <alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
      <coso-alert-message>
        <div class="d-inline" [innerHTML]="errorMessage"></div>
      </coso-alert-message>
    </alert>
    }

    <div class="form-group row">
      <label id="mappingModeLabel" class="col-form-label col-lg-4 col-md-12 text-lg-right">
        Mode
      </label>
      <div class="col-md-12 col-lg-6">
        <div class="btn-group-toggle">
          <button
            type="button"
            name="mappingMode"
            class="btn btn-primary d-block d-sm-inline-block"
            [class.active]="formGroup.controls['mappingMode'].value === MappingMode.APPEND"
            (click)="formGroup.controls['mappingMode'].setValue(MappingMode.APPEND)"
            [disabled]="isReadOnly"
            placement="top"
            tooltip="Custom mapping will be appended to predefined mapping (Append)."
            aria-labelledby="mappingModeLabel"
          >
            Automatic
          </button>
          <button
            type="button"
            name="mappingMode"
            class="btn btn-primary d-block d-sm-inline-block"
            [class.active]="formGroup.controls['mappingMode'].value === MappingMode.REPLACE"
            (click)="formGroup.controls['mappingMode'].setValue(MappingMode.REPLACE)"
            [disabled]="isReadOnly"
            placement="top"
            tooltip="Custom mapping will fully replace predefined mapping (Replace)."
            aria-labelledby="mappingModeLabel"
          >
            Manual
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-{{ isReadOnly ? 'primary' : 'secondary' }}" (click)="activeModal.close()">{{ isReadOnly ? "Close" : "Cancel" }}</button>
    @if (!isReadOnly) {
    <button type="submit" class="btn btn-primary">Save</button>
    }
  </div>
</form>
